module.exports = __webpack_public_path__ + "img/banner-mobile.e62375d1.png";